(() => {
  const initLegalPage = (root) => {
    if (!root || root.dataset.swLegalReady === 'true') return;

    const article = root.querySelector('[data-sw-legal-content]');
    const toc = root.querySelector('[data-sw-legal-toc]');
    const list = root.querySelector('[data-sw-legal-toc-list]');

    if (!article || !toc || !list) return;

    const headings = Array.from(article.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
    if (!headings.length) return;

    root.dataset.swLegalReady = 'true';
    list.replaceChildren();

    const usedIds = new Set();
    const links = [];

    headings.forEach((heading, index) => {
      const baseSlug = heading.textContent
        .trim()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || `section-${index + 1}`;

      let headingId = heading.id || `policy-${baseSlug}`;
      let suffix = 2;
      while (usedIds.has(headingId) || (document.getElementById(headingId) && document.getElementById(headingId) !== heading)) {
        headingId = `policy-${baseSlug}-${suffix}`;
        suffix += 1;
      }

      heading.id = headingId;
      usedIds.add(headingId);

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${headingId}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
      links.push(link);
    });

    toc.hidden = false;

    if ('IntersectionObserver' in window) {
      const setActive = (headingId) => {
        links.forEach((link) => {
          const active = link.getAttribute('href') === `#${headingId}`;
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setActive(visible[0].target.id);
      }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });

      headings.forEach((heading) => observer.observe(heading));
      setActive(headings[0].id);
    }
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-sw-legal]')) initLegalPage(scope);
    scope.querySelectorAll('[data-sw-legal]').forEach(initLegalPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
